/**
 * @file Sends one PDF intake review task (`PdfIntakeTaskRequest`) to
 * `/runlanguagemodel` and throws with the server's own error when it does not
 * confirm success. The one door S2 and S3 write through: cell values
 * (`savePdfIntakeCellValue`), header fields (`savePdfIntakeFieldValue`), column
 * targets (`savePdfIntakeColumnTarget`) and the schedule approval, each with
 * the staging generation it was built from. The server writes, because the
 * reviewer usually does not own the file folder the staging lives in. The
 * `startPdfIntakeSchedule` task (sent by `startPdfIntake`) goes through the
 * same door; only its success is checked, and its result body is not read,
 * since the caller already knows the job id and S2 watches the job document.
 */
import type { PdfIntakeTaskRequest } from '#types';
import { callRunLanguageModel } from '@/services/cloudRun';

export async function callPdfIntakeTask(
  request: PdfIntakeTaskRequest,
): Promise<void> {
  const result = await callRunLanguageModel(request);
  if (result && 'success' in result && result.success) return;
  throw new Error(
    result &&
      'error' in result &&
      typeof result.error === 'string' &&
      result.error !== ''
      ? result.error
      : 'The server did not confirm the change.',
  );
}
